<template>
  <transition name="fade" mode="out-in" v-on:after-leave="onAfterLeave">
    <div class="Quiz" v-if="screening && qualiscore && conclusion">
      <transition name="fade" appear mode="out-in">
        <QuizMotivation v-if="motivation" @nextQuestion="closeMotivation" :key="'motivation'" :count="motivationCount"/>
        <QuizText v-else-if="splashscreen" @nextQuestion="closeSplash" @closeQuiz="$router.push({ name: 'qualiscore-results' })" :data="splashscreen" :template="template" :key="'splash-' + template"/>
        <QuizAdditional :question="datas[currentIndex]" @nextQuestion="nextQuestion" v-else-if="datas[currentIndex] && datas[currentIndex].type == 'annexe'" :key="datas[currentIndex].id" />
        <QuizBase :question="datas[currentIndex]" @nextQuestion="nextQuestion" v-else-if="datas[currentIndex]" :key="datas[currentIndex].id" />
      </transition>
    </div>
    <div class="Quiz" v-else>
      <section class="Quiz_section">
        <div class="Quiz_section_wrapper">
          <h3 class="Quiz_loader">chargement</h3>
          <div class="Loader"></div>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import page from '@/mixins/page'
  import { mapActions, mapState } from 'vuex' 

  import QuizText from "@/components/sections/QuizText"
  import QuizAdditional from "@/components/sections/QuizAdditional"
  import QuizBase from "@/components/sections/QuizBase"
  import QuizMotivation from "@/components/sections/QuizMotivation"

  export default {
    name: "Quiz",
    mixins: [ 'page' ],
    components: { QuizText, QuizBase, QuizAdditional, QuizMotivation },
    metaInfo: {
      title: "J'évalue la qualité de mon logement - Qualitel | Particuliers",
      meta: [
        {
          property: 'og:title',
          content: "J'évalue la qualité de mon logement - Qualitel | Particuliers"
        },
        {
          property: 'og:description',
          content: "L'outil qui vous permet d'évaluer la qualité perçue de votre logement et vous aide à l'améliorer."
        },
        {
          property: 'og:image',
          content: 'https://www.qualitel.org/jevalue-mon-logement/static/images/social/social-2.jpg'
        },
        {
          property: 'twitter:title',
          content: "J'évalue la qualité de mon logement - Qualitel | Particuliers"
        },
        {
          property: 'twitter:description',
          content: "L'outil qui vous permet d'évaluer la qualité perçue de votre logement et vous aide à l'améliorer."
        },
        {
          property: 'twitter:image',
          content: 'https://www.qualitel.org/jevalue-mon-logement/static/images/social/social-2.jpg'
        }
      ]
    },
    data() {
      return {
        screening: null,
        motivation: false,
        qualiscore: null,
        motivationCount: 0,
        splashscreen: null,
        conclusion: null,
        currentIndex: 0,
        template: null
      }
    },
    watch: {
      currentIndex()
      {
        this.template = this.currentIndex >= this.screening.questions.length ? "qualiscore" : "screening"
        
        if(this.datas[this.currentIndex])
        {
          console.log('currentIndex', this.datas[this.currentIndex].ref.replace(/[^0-9]/g, ''))
          console.log('currentTemplate', this.template)
          if(this.datas[this.currentIndex].type != 'annexe')
            this.setQuizIndex({ survey: this.template, index: this.template == 'screening' ? this.datas[this.currentIndex].id : this.datas[this.currentIndex].ref.replace(/[^0-9]/g, '') })

          if(this.datas[this.currentIndex].ref === '9')
          {
            this.motivationCount = this.motivationCount  + 1
            this.motivation = true
          }

          if(this.datas[this.currentIndex].ref === '15')
          {
            this.motivationCount = this.motivationCount  + 2
            this.motivation = true
          }
        }

        if(this.currentIndex == this.datas.length){
          this.template = 'conclusion'
          this.splashscreen = this.conclusion
        }else if(this.currentIndex > this.datas.length)
        {
          console.log('Quiz finish')
          this.$router.push({name: 'qualiscore-results'})
        }
      },
      template()
      {
        if(this.template == 'screening' && this.currentIndex == 0)
        {
          this.splashscreen = this.screening.splashscreen
        }
        if(this.template == 'qualiscore' && this.currentIndex == this.screening.questions.length)
        {
          this.splashscreen = this.qualiscore.splashscreen
        }
        if(this.template == 'conclusion')
        {
          this.splashscreen = this.conclusion
        }
      }
    },
    computed: {
      ...mapState([
        'user'
      ]),
      datas()
      {
        let questions = this.screening.questions.concat(this.qualiscore.questions)
        let results = []

        questions.forEach(question => {
          if(question.visible == 1)
            results.push(question)
        })
        return results
      }
    },
    beforeRouteEnter (to, from, next) {
      var data = {}
      Vue.$api.getSplashscreen('merci')
      .then(response => {
        data.conclusion = response.data

        Vue.$api.getScreening(store.state.user.token)
        .then(response => {
          data.screening = response.data.data

           Vue.$api.getQualiscore(store.state.user.token)
          .then(response => {
            data.qualiscore = response.data.data
            next(vm => vm.setData(data))
          })
        })
      })
    },
    methods: {
      ...mapActions([
        'setQuiz',
        'setQuizIndex',
        'setUserResponses'
      ]),
      onAfterLeave()
      {
        console.log('onAfterLeave')
        document.body.scrollTop = 0
      },
      setData(data)
      {
        this.conclusion = data.conclusion
        this.screening = data.screening
        this.qualiscore = data.qualiscore

        this.setQuiz({ qualiscore: this.qualiscore, screening: this.screening })

        console.log(this.screening)
        this.checkQuestions()
      },
      // fetchData () {
      //   this.$api.getSplashscreen('merci')
      //   .then(response => {
      //     this.conclusion = response.data
      //   })

      //   this.$api.getScreening(this.user.token)
      //   .then(response => {
      //     // console.log(response.data.data.questions)
      //     this.screening = response.data.data

      //     this.$api.getQualiscore(this.user.token)
      //     .then(response => {
      //       this.qualiscore = response.data.data
      //       this.setQuiz({ qualiscore: this.qualiscore, screening: this.screening })

            
      //     })
      //   })
      // },
      checkQuestions()
      {
        this.template = "screening"
        this.datas.forEach( (question, index) => {
          if(question.participantAnswer)
          {
            console.log('already', question.id)
            this.currentIndex = index + 1
            // this.currentIndex = 11

            console.log(this.currentIndex, question)

            this.setUserResponses({ question: question.ref, answer: question.participantAnswer.id ? question.participantAnswer.id : question.participantAnswer })
          }
        })

        // this.setQuizIndex(this.datas[this.currentIndex].id)
      },
      closeSplash()
      {
        this.splashscreen = null
      },
      closeMotivation()
      {
        this.motivation = false
      },
      nextQuestion()
      {
        this.currentIndex = this.currentIndex + 1

        // if(this.datas[this.currentIndex - 1] && !this.datas[this.currentIndex - 1].subquestions)
          // if(this.currentIndex >= 14 ){
          //   this.setQuizIndex(this.currentIndex - 1)
          // }
          // else
          //   this.setQuizIndex(this.currentIndex)
      }
    },
    beforeDestroy()
    {
      document.body.style.position = null
    },
    created()
    {
      // this.fetchData()
      document.body.style.position = 'fixed'
    }
  }
</script>

<style lang="stylus">
.Quiz_section

  height 100%

  &.fade-enter-active

    transition opacity 0.6s $ease
    
  &.fade-leave-active

    transition opacity 0.3s $ease

  @media $medium 

    padding-bottom 55px
    box-sizing border-box

  &_wrapper

    padding  $s-xs $s-xs 
    width 100%
    box-sizing border-box
    margin auto
    display flex
    flex-direction column
    align-items center
    height calc(100vh - 60px - 110px)
    height calc((100vh - 60px - 110px) - var(--vh, 0px));
    justify-content space-around

    @media $medium

      height calc(100vh - 60px - 55px)
      height calc((100vh - 60px - 55px) - var(--vh, 0px));
      // overflow-y auto
      position absolute
      top 0px
      left 0px
      -webkit-overflow-scrolling touch

.Quiz

  &:before

    content ''
    position fixed
    // bottom 60px
    // left 50%
    // width 185px
    // border-radius 25px
    // transform translateX(-50%)
    // height 50px
    background-color $red

    @media $small

      bottom 0px
      left 0px
      right 0px
      border-radius 0px
      transform none
      width 100%
      height 55px

  &_loader

    color $blue
    margin-top auto

  &_content

    text-align center
    max-width 780px
    width 100%
    box-sizing border-box
    margin auto

  &_answers

    display flex
    flex-direction row
    align-items stretch
    justify-content center
    margin $s-xl auto auto auto
    transition-delay 0.2s

    .QuizAnswer

      margin 0px 10px

    @media $medium

      display block
      margin $s-l auto auto auto
      width 100%

      .QuizAnswer

        margin 10px 0px 0px 0px

        &:first-child

          margin-top 0px

    @media $xxsmall

      margin-top 30px

  &_cta

    padding 0px 35px
    box-sizing border-box

    i.fade-enter-active, i.fade-leave-active

      transition opacity 0.2s $ease

    .fa-spinner-third

      animation rotate 0.6s linear infinite forwards

    @media $medium

      position fixed
      bottom 0px
      left 0px
      right 0px
      width 100%
      padding 0px
      height 55px
      border-radius 0px

  &_question

    font-size 30px
    color $blue
    line-height 36px
    transition-delay 0.05s
    margin auto auto
    width 100%
    max-width auto

    @media screen and (max-height: 760px)

      font-size 24px
      line-height 28px
      max-width 960px

    @media $medium

      font-size 18px
      line-height 22px

    @media $xsmall

      font-size 15px
      line-height 18px

  &_title

    font-size 16px
    line-height 24px
    color $s1
    margin auto auto
    text-transform uppercase
    font-weight normal
    margin-bottom 20px

    @media $medium

      font-size 12px
      line-height 16px

    @media $xsmall

      margin-bottom 10px

  &_indic

    margin-top 20px
    font-size 16px
    line-height 24px
    transition-delay 0.1s
    color $s1

    @media $medium

      font-size 14px
      line-height 22px

    @media $xxsmall

      font-size 10px
      line-height 16px

    &_between

      margin-bottom 20px
      display none
      text-align center

      @media $medium

        display block

      @media $xsmall

        margin-bottom 10px

    &_after

      display none
      text-align center

      @media $medium

        display block

    @media $xsmall

      margin-top 10px
  
  &_illustration

    position relative
    width 100%
    max-width 390px
    display block
    margin auto
    transition-delay 0.15s
    transition opacity 0.6s
    // padding-top 60%

    @media $large

      max-width 320px

    @media $medium

      max-width 668px

    @media $xsmall

      width 70%

    @media $xxsmall

      width 60%

    &_image

      // position absolute
      // top 0px
      // left 0px
      // right 0px
      // bottom 0px
      width 100%
      display block

      &_bodymovin

        transition opacity 0.6s $ease

.ie

  .Quiz

    padding-top 80px

    &_illustration

      transform scale(1.5)
</style>